import script from "./RoomItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomItem.vue?vue&type=script&setup=true&lang=js"

import "./RoomItem.vue?vue&type=style&index=0&id=be587b54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be587b54"]])

export default __exports__